import { lazy, Suspense } from 'react'
import { Modal, Spin } from 'antd'
import { prefetchRenderers } from './fileViewerRenderers'

// 预览内核(渲染器约 3.9MB)放在懒加载边界内;
// 外壳只依赖 antd, 点击附件即可弹出弹窗, 重包在后台流式加载
const FileViewerLazy = lazy(() => import('./FileViewerLazy'))

const isBlobLike = (value) => typeof Blob !== 'undefined' && value instanceof Blob

/**
 * 附件预览弹窗
 * @property {object} fileItem - antd Upload 附件项(本地 File), 或 { name, fullPath }(服务端附件)
 * @property {function} onClose - 关闭回调
 */
const FileViewerModal = ({ fileItem, onClose }) => {
  const source = fileItem || {}
  // antd 的附件项可能是 File 本身, 也可能是包装过的 UploadFile
  const localFile = source.originFileObj || source
  const name = source.name

  return (
    <Modal open title={name} footer={null} width='90%' style={{ top: 24 }} styles={{ body: { height: '78vh', padding: 0 } }} onCancel={onClose}>
      <Suspense
        fallback={
          <div className='w-full h-full flex items-center justify-center'>
            <Spin />
          </div>
        }>
        <FileViewerLazy file={isBlobLike(localFile) ? localFile : undefined} url={source.fullPath} name={name} />
      </Suspense>
    </Modal>
  )
}

// 预取: 附件出现时提前拉取预览底座与对应渲染器
export const prefetchFileViewer = (name) => {
  import('./FileViewerLazy').catch(() => {})
  if (name) prefetchRenderers(name)
}

export default FileViewerModal
